var echarts = require("echarts");

export var graphData = {
    computed : {
        // stackedBarGraph : function(){
        //     return {
        //         title : {
        //             show : true,
        //             color: '#000',
        //         },
        //         tooltip: {
        //             // trigger: 'axis',
        //             formatter : (params)=>(`${params.name} : ${params.value} Total recos`),
        //         },
        //         legend: {
        //             show: false,
        //             data: this.barGraphLegends
        //         },
        //         grid: {
        //             left: '3%',
        //             right: '4%',
        //             bottom: '3%',
        //             containLabel: true
        //         },
        //         // dataset: this.stacked_bar_graph_dataset,
        //         yAxis: this.stacked_bar_graph_yaxis,
        //         xAxis: this.stacked_bar_graph_xaxis,
        //         color: this.stacked_bar_graph_colors,
        //         series: this.stacked_bar_graph_series,
        //     }
        // },

        stackedBarGraph : function(){
            return {
                title : {
                    show : true,
                    color: '#000',
                },
                tooltip: {
                    // trigger: 'axis',
                    // formatter : (params)=>(`${params.marker} ${params.name} ${params.value[params.componentIndex + 1]}`),
                    // formatter: params=>(console.log(params))

                    //for stacked graph.. componentIndex 0 is first graph and componentIndex 1 second graph..for graph 1 displayd total of graph one and graph second
                    formatter: function (value, index) {
                        if(value.componentIndex){
                            return (`${value.marker} ${value.name} ${value.data[2]} Total`);
                        }else if(value.componentIndex == 0){
                            return (`${value.marker} ${value.name} ${value.data[1]} Live`);
                        }else{
                            return (`${value.marker} ${value.name} ${value.data[params.componentIndex + 1]}`);
                        }
                    },
                    textStyle: {
                        fontSize: 11
                    }
                },
                legend: {
                    show: false,
                    data: this.barGraphLegends
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                dataset: this.stacked_bar_graph_dataset,
                yAxis: this.stacked_bar_graph_yaxis,
                xAxis: this.stacked_bar_graph_xaxis,
                color: this.stacked_bar_graph_colors,
                series: this.stacked_bar_graph_series,
            }
        },

        simpleBarGraph : function(){
            return {
                title : {
                    show : true,
                    color: '#000',
                },
                tooltip: {
                    trigger: 'item',
                    formatter: this.isCustomFormatterRequired ? (params)=>(`${params.marker} ${params.name} ${params.value[params.componentIndex + 1]}`) : {},
                    textStyle: {
                        fontSize: 11
                    }
                },
                legend: {
                    show: false,
                    data: this.barGraphLegends
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                dataset: this.simple_bar_graph_dataset,
                yAxis: this.simple_bar_graph_yaxis,
                xAxis: this.simple_bar_graph_xaxis,
                color: this.is_multi_graph_color ? this.horizontal_bar_graph_colors : this.single_bar_graph_color,
                series: this.is_singleSeriesObjRequired ? this.simple_bar_graph_single_series_obj : this.simple_bar_graph_multiple_series_obj,
            }
        },

        horizontalBarGraphPartA : function(){
            return {
                title : {
                    show : true,
                    color: '#000',
                },
                tooltip: {
                    // trigger: 'axis',
                    formatter : this.horizontal_graph_A_normalised_axis ? (params) => (`${params.marker} ${params.name} : ${params.value}`) : (params) => (`${params.marker} ${params.name} : ${params.value} %`),
                    textStyle: {
                        fontSize: 11
                    }
                },
                grid: {
                    left: '0%',
                    top: '15%',
                    // right: '4%',
                    // bottom: '3%',
                    containLabel: true
                },
                yAxis: this.horizontal_bar_graph_yaxis_A,
                xAxis: this.horizontal_bar_graph_xaxis_A,
                color: this.horizontal_bar_graph_colors,
                series: this.horizontal_bar_graph_series_A,
            }
        },

        horizontalBarGraphPartB : function(){
            return {
                title : {
                    show : true,
                    color: '#000',
                },
                tooltip: {
                    // trigger: 'axis',
                    formatter : this.horizontal_graph_B_normalised_axis ? (params) => (`${params.marker} ${params.name} : ${params.value}`) : (params) => (`${params.marker} ${params.name} : ${params.value} %`),
                    textStyle: {
                        fontSize: 11
                    }
                },
                grid: {
                    left: '0%',
                    top: '15%',
                    // right: '4%',
                    // bottom: '3%',
                    containLabel: true
                },
                yAxis: this.horizontal_bar_graph_yaxis_B,
                xAxis: this.horizontal_bar_graph_xaxis_B,
                color: this.horizontal_bar_graph_colors,
                series: this.horizontal_bar_graph_series_B,
            }
        },

        horizontalBarGraphPartC : function(){
            return {
                title : {
                    show : true,
                    color: '#000',
                },
                tooltip: {
                    // trigger: 'axis',
                    formatter : this.horizontal_graph_C_normalised_axis ? (params) => (`${params.marker} ${params.name} : ${params.value}`) : (params) => (`${params.marker} ${params.name} : ${params.value} %`),
                    textStyle: {
                        fontSize: 11
                    }
                },
                grid: {
                    left: '0%',
                    top: '15%',
                    // right: '4%',
                    // bottom: '3%',
                    containLabel: true
                },
                yAxis: this.horizontal_bar_graph_yaxis_C,
                xAxis: this.horizontal_bar_graph_xaxis_C,
                color: this.horizontal_bar_graph_single_colors,
                series: this.horizontal_bar_graph_series_C,
            }
        },

        customBarGraph : function(){
            return {
                title : {
                    show : true,
                    color: '#000',
                },
                tooltip: {
                    trigger: 'item',
                    formatter: params=>(`${params.marker} ${params.name} ${params.value}`),
                    textStyle: {
                        fontSize: 11
                    }
                },
                grid: {
                    left: '0%',
                    top: '15%',
                    containLabel: true
                },
                color: this.horizontal_bar_graph_colors,
                series: this.custom_bar_graph_series,
                yAxis: this.custom_bar_graph_series_yaxis,
                xAxis: this.custom_bar_graph_series_xaxis,
            }
        },

        customBarGraphB : function(){
            return {
                title : {
                    show : true,
                    color: '#000',
                },
                tooltip: {
                    trigger: 'item',
                    formatter: params=>(`${params.marker} ${params.name} ${params.value}`),
                    textStyle: {
                        fontSize: 11
                    }
                },
                grid: {
                    left: '0%',
                    top: '15%',
                    containLabel: true
                },
                color: this.horizontal_bar_graph_colors,
                series: this.custom_bar_graph_series_B,
                yAxis: this.custom_bar_graph_series_yaxis_B,
                xAxis: this.custom_bar_graph_series_xaxis_B,
            }
        },

        gaugeGraph : function() {
            return {
                // tooltip: {
                //     formatter: '{a} <br/>{b} : {c}%'
                // },
                series : [
                    {
                        name: '',
                        type:'gauge',
                        startAngle: 180,
                        endAngle: 0,
                        center : ['50%', '75%'],    // ??????
                        radius : '100%',

                        splitLine: {
                            show: false
                        },

                        axisTick: {
                            show: false,
                        },

                        axisLabel: {
                            show: false ,
                            textStyle: {
                                    color: '#fff',
                                    fontSize: 15,
                                    fontWeight: 'bolder'
                                }
                        },

                        axisLine: {
                            lineStyle: {
                                width: 10,
                                color : [[0.2, '#2dcab3'], [0.8, '#f2bd4c'], [1, '#ed5950']]
                            }
                        },

                        pointer: {
                            width: 2,
                            length: '60%',
                            color: 'rgba(255, 255, 255, 0.8)'
                        },

                        title : {
                            show : false,
                            offsetCenter: [0, '-60%'],
                            textStyle: {
                                color: '#fff',
                                fontSize: 30
                            }
                        },

                        detail : {
                            show : false,
                            backgroundColor: 'rgba(0,0,0,0)',
                            borderWidth: 0,
                            borderColor: '#ccc',
                            width: 100,
                            height: 40,
                            offsetCenter: [0, -40],
                            formatter: '{value}',
                            textStyle: {
                                fontSize : 50
                            }
                        },
                        data: this.gauge_graph_series
                    }
                ]
            }
        },

        recoCountGraph : function() {
            return {
                title: {
                    show: true ,
                    text: 'Term',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: '12',
                        fontFamily: 'Montserrat' ,
                    },
                },
                tooltip: {
                    trigger: 'item',
                    show: true,
                    formatter: params=>(`${params.marker} ${params.name} : ${params.value}`),
                    // formatter: params=>(`${params.marker} ${params.name} : ${params.value} </br> &nbsp;&nbsp;&nbsp;&nbsp; ROI : ${params.data.meta_data}%`),
                },
                legend: {
                    top: '5%',
                    left: 'center',
                    show: false
                },
                series: this.reco_count_series
            }
        },

        protfolidOverviewGraph : function() {
            return {
                title: this.chart_title_obj,
                // tooltip: {
                //     formatter: '{a} <br/>{b} : {c}%'
                // },
                tooltip: {
                    trigger: 'item',
                    show: true,
                    formatter: function(params){
                        return `${params.marker} ${params.name.length > 12 ? (params.name.slice(0, 8)+"...") : params.name} </br> Weightage : ${params.value} % </br> ROI : ${params.data.meta_data.absolute_roi} %`;
                    },
                },
                series: this.portfolio_overview_series
            }
        },

        accuracyPieChart : function() {
            return {
                title: this.chart_title_obj,
                tooltip: this.customizedToolTip,
                legend: this.chart_legend,
                series: this.accuracy_pie_chart_series
            }
        },

        successRatePieChart : function() {
            return {
                title: this.chart_title_obj,
                tooltip: this.customizedToolTip,
                legend: this.chart_legend,
                series: this.success_rate_pie_chart_series
            }
        },

        recoStatusPieChart : function() {
            return {
                title: {
                    show: true ,
                    text: 'Status',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: '12',
                        fontFamily: 'Montserrat' ,
                    },
                },
                tooltip: {
                    trigger: 'item',
                    show: true,
                    formatter: params=>(`${params.marker} ${params.name.length > 12 ? (params.name.slice(0, 8)+"...") : params.name} ${params.value}`),
                },
                legend: this.chart_legend,
                series: this.reco_status_pie_chart_series
            }
        },
    },

    data () {
        return {
            customizedToolTip: {
                trigger: 'item',
                show: true,
                formatter: params=>(`${params.marker} ${params.name.length > 12 ? (params.name.slice(0, 8)+"...") : params.name} ${params.value} %`),
            },
            chart_title_obj: {
                show: true ,
                text: 'Stocks',
                x: 'center',
                y: 'center',
                textStyle: {
                    fontSize: '12',
                    fontFamily: 'Montserrat' ,
                },
            },

            chart_legend: {
                top: '5%',
                left: 'center',
                show: false
            },

            barGraphLegend: {
                type: 'scroll',
                itemGap : 20,
                top: 10,
                show: true,
            },

            isCustomFormatterRequired: true,
            is_multi_graph_color: true,
            is_singleSeriesObjRequired: true,
            horizontal_graph_A_normalised_axis: false,
            horizontal_graph_B_normalised_axis: false,
            horizontal_graph_C_normalised_axis: false,
            single_bar_graph_color: ['#b6d094'],
            stacked_bar_graph_colors: ['#09a6d0', '#e55575'],
            horizontal_bar_graph_colors: ['#e55575', '#09a6d0', '#fcaa8e', '#5bc9d3', '#9db7d0', '#ff6b45', '#ffb133', '#6963db', '#d340be', '#ff408e', '#0e1159'],

            horizontal_bar_graph_single_colors: ['#e55575'],

            // stacked bar graph config
            // stacked_bar_graph_series: {
            //     data: [],
            //     type: 'bar',
            //     barWidth: "35",
            //     label : {
            //         show: true,
            //         position: 'top',
            //         color: function(value){
            //             console.log('value', value);
            //         }
            //         // backgroundColor: '#000',
            //         // formatter: "{c}"
            //     }
            // },
            // stacked_bar_graph_yaxis: {
            //     min: "0",           //do not remove this..minimum value to show on y axis
            //     axisLabel:{
            //         fontStyle: 'normal' ,
            //         fontWeight: 500 ,
            //         fontFamily: 'Montserrat' ,
            //         fontSize: 10,
            //         margin: 15,
            //         color: '#000',
            //     },
            //     axisTick: {
            //         show: false,
            //     },
            //     axisLine: {
            //         show: true,
            //         lineStyle: {
            //             color: '#bcbcbc' ,
            //             width: 2 ,
            //         }
            //     },
            //     type: 'value',
            //     scale : true,
            //     splitLine: {
            //         show:  true,
            //         lineStyle: {
            //             color: ['#f2f2f2'] ,
            //             width: 1
            //         }
            //     }
            // },

            // stacked_bar_graph_dataset: {
            //     source: []
            // },
            // stacked_bar_graph_xaxis:{
            //     data: [],
            //     axisLabel: {
            //         fontStyle: 'normal' ,
            //         fontWeight: 500 ,
            //         fontFamily: 'Montserrat' ,
            //         fontSize: 10,
            //         // margin: 15,
            //         color: '#000',
            //         // rotate: 10
            //         formatter: function (value, index) {
            //             return (value.split(' ')).join('\n');
            //         },
            //     },
            //     axisTick: {
            //         show: true,
            //     },
            //     axisLine: {
            //         show: true,
            //         lineStyle: {
            //             color: '#bcbcbc' ,
            //             width: 2 ,
            //         }
            //     },
            //     splitLine: { show: false},
            //     type: 'category',
            // },

            stacked_bar_graph_series:[],
            stacked_bar_graph_yaxis: [
                {gridIndex: 0,
                min: "0",           //do not remove this..minimum value to show on y axis
                axisLabel:{
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    fontSize: 10,
                    margin: 15,
                    color: '#000',
                },
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#bcbcbc' ,
                        width: 2 ,
                    }
                },
                type: 'value',
                scale : true,
                    splitLine: { show:  true,
                        lineStyle: {
                            color: ['#f2f2f2'] ,
                            width: 1
                        }
                    }
                }
            ],
            stacked_bar_graph_dataset: {
                source: []
            },
            stacked_bar_graph_xaxis:{
                axisLabel: {
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    fontSize: 10,
                    // margin: "",
                    color: '#000',
                    // rotate: "",
                    width: 10,
                    // formatter: function (value, index) {
                    //     return (value.split(' ')).join('\n');
                    // },
                    formatter: function (value) {
                        return (value.length > 12 ? (value.slice(0, 12)+"...") : value )
                    },
                },
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#bcbcbc' ,
                        width: 2 ,
                    }
                },
                splitLine: { show: false},
                type: 'category',
            },

            // simmple bar graph config

            simple_bar_graph_yaxis: [
                {
                    gridIndex: 0,
                    min: "0",           //do not remove this..minimum value to show on y axis
                    axisLabel:{
                        fontStyle: 'normal' ,
                        fontWeight: 500 ,
                        fontFamily: 'Montserrat' ,
                        fontSize: 10,
                        margin: 15,
                        color: '#000',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#bcbcbc' ,
                            width: 2 ,
                        }
                    },
                    type: 'value',
                    scale : true,
                    splitLine: {
                        show:  true,
                        lineStyle: {
                            color: ['#f2f2f2'] ,
                            width: 1
                        }
                    }
                }
            ],

            simple_bar_graph_xaxis: {
                axisLabel: {
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    fontSize: 10,
                    // margin: 15,
                    color: '#000',
                    // rotate: 10,
                    // formatter: function (value, index) {
                    //     return (value.split(' ')).join('\n');
                    // },
                    formatter: function (value) {
                        return (value.length > 12 ? (value.slice(0, 12)+"...") : value )
                    },
                },
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#bcbcbc' ,
                        width: 2 ,
                    }
                },
                splitLine: { show: false},
                type: 'category',
            },

            simple_bar_graph_dataset: {
                source : []
            },

            simple_bar_graph_single_series_obj: {
                data: [],
                type: 'bar',
                barWidth: "35"
            },

            simple_bar_graph_multiple_series_obj: [],

            // horizontal bar graph A config
            horizontal_bar_graph_series_A:[
                {
                    data : [],
                    type: 'bar',
                    barWidth: 10,
                },
            ],
            horizontal_bar_graph_yaxis_A: {
                data: [],
                type: 'category',
                axisTick: { show: false},
                axisLabel: {
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    fontSize: 10,
                    margin: 15,
                    color: '#000',
                    // formatter: function (value, index) {
                    //     return (value.split(' ')).join('\n');
                    // },
                    formatter: function (value) {
                        return (value.length > 12 ? (value.slice(0, 12)+"...") : value )
                    },
                },
                axisLine: {
                    lineStyle: {
                        color: '#bcbcbc' ,
                        width: 2 ,
                    }
                }
            },
            horizontal_bar_graph_xaxis_A:{
                splitLine: { show: false},
                axisLabel: {
                    formatter : "",
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    fontSize: 10,
                    color: '#000'
                },
                axisLine: {
                    lineStyle: {
                        color: '#bcbcbc' ,
                        width: 2 ,
                    }
                }
            },

            // horizontal bar graph B config
            horizontal_bar_graph_series_B:[
                {
                    data : [],
                    type: 'bar',
                    barWidth: 10,
                },
            ],
            horizontal_bar_graph_yaxis_B: {
                data: [],
                type: 'category',
                axisTick: { show: false},
                axisLabel: {
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    fontSize: 10,
                    margin: 15,
                    color: '#000',
                    // formatter: function (value, index) {
                    //     return (value.split(' ')).join('\n');
                    // },
                    formatter: function (value) {
                        return (value.length > 12 ? (value.slice(0, 12)+"...") : value )
                    },
                },
                axisLine: {
                    lineStyle: {
                        color: '#bcbcbc' ,
                        width: 2 ,
                    }
                }
            },
            horizontal_bar_graph_xaxis_B:{
                splitLine: { show: false},
                axisLabel: {
                    formatter : "",
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    fontSize: 10,
                    color: '#000'
                },
                axisLine: {
                    lineStyle: {
                        color: '#bcbcbc' ,
                        width: 2 ,
                    }
                }
            },

            // horizontal bar graph C config
            horizontal_bar_graph_series_C:[
                {
                    data : [],
                    type: 'bar',
                    barWidth: 10,
                },
            ],
            horizontal_bar_graph_yaxis_C: {
                data: [],
                type: 'category',
                axisTick: { show: false},
                axisLabel: {
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    fontSize: 10,
                    margin: 15,
                    color: '#000',
                    // formatter: function (value, index) {
                    //     return (value.split(' ')).join('\n');
                    // },
                    formatter: function (value) {
                        return (value.length > 12 ? (value.slice(0, 12)+"...") : value )
                    },
                },
                axisLine: {
                    lineStyle: {
                        color: '#bcbcbc' ,
                        width: 2 ,
                    }
                }
            },
            horizontal_bar_graph_xaxis_C:{
                splitLine: { show: false},
                axisLabel: {
                    formatter: "",
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    fontSize: 10,
                    color: '#000'
                },
                axisLine: {
                    lineStyle: {
                        color: '#bcbcbc' ,
                        width: 2 ,
                    }
                }
            },

            // custom bar graph config
            custom_bar_graph_series_xaxis: {
                axisLabel: {
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    fontSize: 10,
                    // margin: 15,
                    color: '#000',
                    // rotate: 45,
                    // width: "10%",
                    // formatter: function (value, index) {
                    //     return (value.split(' ')).join('\n');
                    // },
                    formatter: function (value) {
                        return (value.length > 12 ? (value.slice(0, 12)+"...") : value )
                    },
                },
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#bcbcbc' ,
                        width: 2 ,
                    }
                },
                splitLine: { show: false},
                type: 'category',
                data: []
            },
            custom_bar_graph_series_yaxis: {
                min: "0",           //do not remove this..minimum value to show on y axis
                axisLabel:{
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    fontSize: 10,
                    margin: 15,
                    color: '#000',
                },
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#bcbcbc' ,
                        width: 2 ,
                    }
                },
                type: 'value',
                scale : true,
                splitLine: { show:  true,
                    lineStyle: {
                        color: ['#f2f2f2'] ,
                        width: 1
                    }
                }
            },
            custom_bar_graph_series: {
                data: [],
                type: 'bar',
                barWidth: 35
            },

            // custom bar graph config
            custom_bar_graph_series_xaxis_B: {
                axisLabel: {
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    fontSize: 10,
                    // margin: 15,
                    color: '#000',
                    // rotate: 45,
                    // width: "10%",
                    // formatter: function (value, index) {
                    //     return (value.split(' ')).join('\n');
                    // },

                    formatter: function (value) {
                        return (value.length > 12 ? (value.slice(0, 12)+"...") : value )
                    },
                },
                axisTick: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#bcbcbc' ,
                        width: 2 ,
                    }
                },
                splitLine: { show: false},
                type: 'category',
                data: []
            },
            custom_bar_graph_series_yaxis_B: {
                min: "0",           //do not remove this..minimum value to show on y axis
                axisLabel:{
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    fontSize: 10,
                    margin: 15,
                    color: '#000',
                },
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#bcbcbc' ,
                        width: 2 ,
                    }
                },
                type: 'value',
                scale : true,
                splitLine: { show:  true,
                    lineStyle: {
                        color: ['#f2f2f2'] ,
                        width: 1
                    }
                }
            },
            custom_bar_graph_series_B: {
                data: [],
                type: 'bar',
                barWidth: 35
            },

            gauge_graph_series: [],

            portfolio_overview_series: [
                {
                //   name: 'Access From',
                  type: 'pie',
                //   selectedMode: 'single',
                  radius: ['40%', '50%'],
                  label: {
                    show: false,
                    // position: 'inner',
                    fontSize: 14
                  },
                  labelLine: {
                    // show: false
                  },
                  data: []
                },
                {
                //   name: 'Access From',
                  type: 'pie',
                  radius: ['50%', '65%'],
                  labelLine: {
                    length: 30
                  },
                  label: {
                    // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                    backgroundColor: '#F6F8FC',
                    borderColor: '#8C8D8E',
                    borderWidth: 1,
                    borderRadius: 4,
                    show: false,
                    // rich: {
                    //   a: {
                    //     color: '#6E7079',
                    //     lineHeight: 22,
                    //     align: 'center'
                    //   },
                    //   hr: {
                    //     borderColor: '#8C8D8E',
                    //     width: '100%',
                    //     borderWidth: 1,
                    //     height: 0
                    //   },
                    //   b: {
                    //     color: '#4C5058',
                    //     fontSize: 14,
                    //     fontWeight: 'bold',
                    //     lineHeight: 33
                    //   },
                    //   per: {
                    //     color: '#fff',
                    //     backgroundColor: '#4C5058',
                    //     padding: [3, 4],
                    //     borderRadius: 4
                    //   }
                    // }
                  },
                  data: []
                }
            ],

            reco_count_series: [
                {
                    type: 'pie',
                    radius: ['50%', '65%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    // emphasis: {
                    //     label: {
                    //         show: true,
                    //         fontSize: '14',
                    //         // fontWeight: 'bold'
                    //     }
                    // },
                    labelLine: {
                        show: false
                    },
                    data: [],
                    emphasis: {
                        focus: 'self'
                    },
                    // emphasis: {
                    //     itemStyle: {
                    //       shadowBlur: 10,
                    //       shadowOffsetX: 0,
                    //       shadowColor: 'rgba(0, 0, 0, 0.5)'
                    //     }
                    // }
                }
            ],

            reco_status_pie_chart_series: [
                {
                    type: 'pie',
                    radius: ['50%', '65%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: false,
                            fontSize: '14',
                            // fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: []
                }
            ],

            accuracy_pie_chart_series: [
                {
                  type: 'pie',
                  radius: ['40%', '50%'],
                  label: {
                    show: false,
                  },
                  data: []
                },
                {
                  type: 'pie',
                  radius: ['50%', '65%'],
                  label: {
                    show: false,
                  },
                  data: []
                }
            ],

            success_rate_pie_chart_series: [
                {
                  type: 'pie',
                  radius: ['40%', '50%'],
                  label: {
                    show: false,
                  },
                  data: []
                },
                {
                  type: 'pie',
                  radius: ['50%', '65%'],
                  label: {
                    show: false,
                    backgroundColor: '#F6F8FC',
                    borderColor: '#8C8D8E',
                    borderWidth: 1,
                    borderRadius: 4,
                  },
                  data: []
                }
            ],

            initOptions : {renderer : 'svg'},
            loading: true,
        }
    }
}
